<template>
  <section class="content">
    <div class="row center-block">
      <!--<h2>Data tables</h2>-->
      <div class="col-md-12">
        <copy-ad-form/>
      </div>
    </div>
  </section>
</template>

<script>
import copyAdForm from './Temp/CopyAdTemp.vue'

export default {
  name: 'Tables',
  data () {
    return {
      info: {
        name: '光復店',
        des: '滿200外送'
      }
    }
  },
  components: {
    'copy-ad-form': copyAdForm
  },
  computed: {
    checkInput () {
      return this.$parent.checkInput
    },
    getDataH () {
      return this.$parent.getDataH
    },
    getData () {
      return this.$parent.getData
    }
  }
}
</script>



// WEBPACK FOOTER //
// CopyAd.vue?7e99a78f